import { useUserPermission } from '../../../../../hooks/useUserPermission/useUserPermission';
import { BuildingsAddButton } from './buildings-add-button';
import { PortfolioImportButton } from './portfolio-import-button.component';
import { PermissionKeys } from '@client/api';

export function BuildingCreateCta() {
  const { hasAnyPermission } = useUserPermission();
  if (!hasAnyPermission([PermissionKeys.Tenant.SpaceCreate])) return null;
  return (
    <>
      <BuildingsAddButton />
      <PortfolioImportButton />
    </>
  );
}
